import { Col, Row } from '@/shared/ui/Grid'

import styles from './DeliveryNotes.module.scss'

export const DeliveryNotes = () => (
	<section className={styles.deliveryNotes}>
		<Row>
			<Col lg={12} xs={24}>
				<p className={styles.text}>
					Для оплаты товара с помощью банковской карты необходимо выбрать пункт «Онлайн-оплата банковской картой» в
					корзине. После оформления заказа необходимо нажать на кнопку «Оплатить онлайн». Оплата происходит через ПАО
					СБЕРБАНК.
				</p>
			</Col>
			<Col lg={12} xs={24}>
				<p className={styles.text}>
					Для оплаты (ввода реквизитов вашей карты) вы будете перенаправлены на платежный шлюз ПАО СБЕРБАНК. Соединение
					с платежным шлюзом и передача информации осуществляется в защищенном режиме с использованием протокола
					шифрования SSL. Если ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By
					Visa или MasterCard SecureCode, для проведения платежа также может потребоваться ввод специального пароля.
					Сайт iport.ru поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации
					обеспечивается ПАО СБЕРБАНК. Введённая информация не будет предоставлена третьим лицам за исключением случаев,
					предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом
					соответствии с требованиями платежных систем МИР, Visa Int. и MasterCard Europe Sprl.
				</p>
			</Col>
		</Row>
	</section>
)
